module.exports = __webpack_public_path__ + "fonts/nationale-bold.074bd25.otf";